module.exports = __webpack_public_path__ + "img/t_1.9d4be674.png";